export const PERMS = {
    READ: 'currencies.read',
    UPDATE: 'currencies.update',
    DELETE: 'currencies.delete',
    CREATE: 'currencies.create',
    EXPORT: 'currencies.export',
}
